export const FIELD_TYPES_MAP = {
  ADDRESS: 'ADDRESS',
  ASSET: 'ASSET',
  BOOLEAN: 'BOOLEAN',
  CHECK_BOX: 'CHECK_BOX',
  DATE: 'DATE',
  LONG_TEXT: 'LONG_TEXT',
  MULTI_SELECT: 'MULTI_SELECT',
  MULTIPLE_PHOTO_UPLOAD: 'MULTIPLE_PHOTO_UPLOAD',
  NUMBER_DYNAMIC_CURRENCY_WITH_YEAR: 'NUMBER_DYNAMIC_CURRENCY_WITH_YEAR',
  NUMBER_DYNAMIC_UOM_WITH_YEAR: 'NUMBER_DYNAMIC_UOM_WITH_YEAR',
  NUMBER_DYNAMIC_UOM: 'NUMBER_DYNAMIC_UOM',
  NUMBER_UOM: 'NUMBER_UOM',
  NUMBER: 'NUMBER',
  PASSWORD: 'PASSWORD',
  SELECT: 'SELECT',
  SELECT_WITH_FOLLOW_UP: 'SELECT_WITH_FOLLOW_UP',
  SHORT_TEXT: 'SHORT_TEXT',
  STRING: 'STRING', // This is not used as of 29.08.2024
  TABLE: 'TABLE',
  VIDEO_UPLOAD: 'VIDEO_UPLOAD',
  YES_NO: 'YES_NO',
}

export const FIELD_TYPES_ENUM = Object.keys(FIELD_TYPES_MAP)

export const ASSET_TYPES_MAP = {
  COUNTRIES: 'COUNTRIES',
  PRODUCTION_PROCESSES: 'PRODUCTION_PROCESSES',
  FACILITY_PROCESSES: 'FACILITY_PROCESSES',
}

export const AI_MODELS = {
  GPT_5_4_RETRACED: {
    model: 'gpt-5.4',
    maxTokens: 128000,
    // Read via globalThis: this file is also bundled into frontend-v2, where
    // `process` doesn't exist.
    apiKey: globalThis.process?.env.OPENAI_API_KEY ?? '',
    pricePerThousandInputTokens: 0.005,
    pricePerThousandOutputTokens: 0.015,
  },
}

export const AZURE_AI_TEXT_ANALYTICS_MAX_CHARACTERS = 125000 // As defined in https://learn.microsoft.com/en-us/azure/ai-services/language-service/concepts/data-limits
